import PageFrame from '../../components/PageFrame/PageFrame'
import { useParams } from 'react-router-dom'
import {
  usePlaylistsQuery,
  usePortfolioQuery,
  useTracksQuery,
  useUpdatePlaylistsMutation,
  useUpdatePortfolioMutation,
  useUpdateTrackMutation,
  useUpdateTracksMutation,
} from '../../api/api'
import './portfolio-editor.scss'
import { useEffect, useState } from 'react'
import PortfolioEditorHeader from './PortfolioEditorHeader'
import TemplateProfileRight from './templates/TemplateProfileRight'
import getPortfolioStyles from '../../utils/getPortfolioStyles'
import clsx from 'clsx'
import TemplateProfileLeft from './templates/TemplateProfileLeft'
import TemplateProfileTop from './templates/TemplateProfileTop'
import TemplateProfileBottom from './templates/TemplateProfileBottom'
import TemplatePlayerOnly from './templates/TemplatePlayerOnly'
import LoadingBlocker from '../../components/LoadingSpinner/LoadingBlocker'
import TrackView from '../TrackView/TrackView'
import BulkTrackView from '../TrackView/BulkTrackView'
import useDebounce from '../../utils/hooks/useDebounce'
import GeneralModal from '../../components/GeneralModal/GeneralModal'

const templateMap = {
  profileTop: TemplateProfileTop,
  profileRight: TemplateProfileRight,
  profileLeft: TemplateProfileLeft,
  profileBottom: TemplateProfileBottom,
  playerOnly: TemplatePlayerOnly,
}

/**
 * TODO
 * horizontal align for top/bottom view
 * select size for top/bottom view (small, med, lg, full)
 */

const PortfolioEditorView = ({ user }) => {
  const { id } = useParams()
  const { data: portfolio, isLoading } = usePortfolioQuery(id)

  const [values, setValues] = useState({})
  const [preview, setPreview] = useState(false)
  const [originalValues, setOriginalValues] = useState({})
  const [errorModal, setErrorModal] = useState(null)
  useEffect(() => {
    if (portfolio) {
      setValues(portfolio)
      setOriginalValues(portfolio)
    }
  }, [portfolio, portfolio?.updatedAt])

  const [updatePortfolio, { isLoading: isUpdating }] =
    useUpdatePortfolioMutation()

  const pageData = values.pageData || {}
  const styles = getPortfolioStyles(pageData)
  const { template } = pageData
  const TemplateComponent = templateMap[template] || TemplateProfileRight

  async function handleSave() {
    const result = await updatePortfolio({ id, values })
    if (result?.error) {
      const error = result?.error?.data?.errors?.[0]
      if (error) {
        setErrorModal(error)
      }
    }
  }

  return (
    <PageFrame route="portfolios">
      <div
        className={clsx('portfolio-editor-view flex flex-col h-full relative', {
          light: pageData?.theme === 'light',
        })}
        style={styles}
      >
        {values.id && (
          <>
            <PortfolioEditorHeader
              values={values}
              originalValues={originalValues}
              user={user}
              isPreview={preview}
              onChange={setValues}
              onSave={handleSave}
              onPreview={() => setPreview(!preview)}
            />
            <div className="flex-fill flex overflow-auto">
              <TemplateComponent
                values={values}
                onChange={setValues}
                key={template}
                isPreview={preview}
              />
            </div>
          </>
        )}

        {(isLoading || isUpdating) && <LoadingBlocker />}

        {!!errorModal ? (
          <GeneralModal
            isOpen={!!errorModal}
            onRequestClose={() => setErrorModal(null)}
            title={'Error'}
            hideCancel
            buttons={[
              {
                className: 'button',
                text: 'Close',
                onClick: () => setErrorModal(null),
              },
            ]}
          >
            <p>Unable to save your portfolio: {errorModal?.error}</p>
          </GeneralModal>
        ) : null}
      </div>
    </PageFrame>
  )
}

export default PortfolioEditorView
